import type { RolaKonta } from "@shared/kontaTypy.js";
import {
  IconAnalizy,
  IconCwiczenia,
  IconDeveloper,
  IconKoszty,
  IconMikrofon,
  IconRecenzje,
  IconUstawienia,
} from "../icons/index.js";

/**
 * Pozycje menu bocznego dla kazdej roli. Sidebar dostaje liste przez props, wiec ta sama powloka obsluguje oba konta.
 *
 * Aktywnosc liczy `czyPozycjaAktywna` (lib/nawigacja.ts), a nie NavLink: "Analizy" prowadza na "/", ale pojedyncza
 * analiza to "/analizy/:id" i tez do nich nalezy. Szczegol wywolania (/developer/:id) nalezy do "Developer" z samego
 * prefiksu sciezki.
 *
 * C-1: kazda pozycja ma unikalna ikone. IC-4: Ustawienia to zebatka, nigdy slonce.
 */

export interface PozycjaMenu {
  do: string;
  etykieta: string;
  Ikona: (props: { size?: number; className?: string }) => React.JSX.Element;
  /** Dodatkowe sciezki, ktore tez naleza do tej pozycji. */
  nalezaTez?: readonly string[];
}

/** Administrator: wszystko. Recenzje stoja tuz za Mikrofonem, przed pozycjami konfiguracyjnymi. */
export const POZYCJE_ADMINA: readonly PozycjaMenu[] = [
  { do: "/", etykieta: "Analizy", Ikona: IconAnalizy, nalezaTez: ["/analizy"] },
  { do: "/mikrofon", etykieta: "Mikrofon", Ikona: IconMikrofon },
  { do: "/recenzje", etykieta: "Recenzje", Ikona: IconRecenzje },
  { do: "/ustawienia", etykieta: "Ustawienia", Ikona: IconUstawienia },
  { do: "/koszty", etykieta: "Koszty", Ikona: IconKoszty },
  { do: "/developer", etykieta: "Developer", Ikona: IconDeveloper },
];

/**
 * Konto `user`: dwie pozycje. "Moje rozmowy" to jego lista, a takze wynik pojedynczej rozmowy (/analizy/:id) i nowa
 * rozmowa (/nowa); "Cwiczenia" to trening z symulowanym rozmowca (/cwiczenia i /cwiczenia/:id).
 */
export const POZYCJE_UZYTKOWNIKA: readonly PozycjaMenu[] = [
  { do: "/", etykieta: "Moje rozmowy", Ikona: IconAnalizy, nalezaTez: ["/analizy", "/nowa"] },
  { do: "/cwiczenia", etykieta: "Ćwiczenia", Ikona: IconCwiczenia, nalezaTez: ["/cwiczenia"] },
];

export function pozycjeDlaRoli(rola: RolaKonta): readonly PozycjaMenu[] {
  return rola === "admin" ? POZYCJE_ADMINA : POZYCJE_UZYTKOWNIKA;
}
